import { useState, useEffect } from 'react';

/**
 * Custom hook for managing UI visibility states
 * Handles multiple related UI states and window object integration
 */
export const useUIVisibility = (): {
  showCurrentPasskey: boolean;
  setShowCurrentPasskey: (value: boolean) => void;
  showNewPasskeyField: boolean;
  setShowNewPasskeyField: (value: boolean) => void;
  showSuccessMessage: boolean;
  setShowSuccessMessage: (value: boolean) => void;
  showCancelButton: boolean;
  setShowCancelButton: (value: boolean) => void;
  togglePasskeyVisibility: () => void;
  handleChangePasskey: () => void;
} => {
  const [showCurrentPasskey, setShowCurrentPasskey] = useState<boolean>(false);
  const [showNewPasskeyField, setShowNewPasskeyField] = useState<boolean>(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);
  const [showCancelButton, setShowCancelButton] = useState<boolean>(true);

  /**
   * Toggles visibility of current passkey (show/hide with dots)
   */
  const togglePasskeyVisibility = (): void => {
    setShowCurrentPasskey((prev) => !prev);
  };

  /**
   * Toggles the new passkey input field visibility
   */
  const handleChangePasskey = (): void => {
    setShowNewPasskeyField((prev) => !prev);
  };

  /**
   * Exposes success callback to window object for external form submission handling
   * Allows privacy_settings.js to trigger success state after successful save
   */
  useEffect(() => {
    window.showPasskeySectionSuccess = (): void => {
      setShowSuccessMessage(true);
    };

    return () => {
      delete window.showPasskeySectionSuccess;
    };
  }, []);

  return {
    showCurrentPasskey,
    setShowCurrentPasskey,
    showNewPasskeyField,
    setShowNewPasskeyField,
    showSuccessMessage,
    setShowSuccessMessage,
    showCancelButton,
    setShowCancelButton,
    togglePasskeyVisibility,
    handleChangePasskey
  };
};
